import { authedApiInstance } from '../firebase';

export const getDefaultChatSounds = () =>
  authedApiInstance
    .get('/room/defaultChatSounds')
    .then((response) => response.data)
    .catch((error) => error?.response?.data);
